import { skipToken } from "@tanstack/react-query";
import { FIVE_MINUTES_MS } from "@remi/constants";

import { api } from "~/utils/api";
import { getQueryConfig } from "~/utils/query-config";

// Hoisted to module scope so Math.random() runs once. Per-render calls produce
// a new staleTime value each render; React Query's shallowEqualObjects detects
// the changed value, fires observerOptionsUpdated, and resets the stale
// timeout — causing a refetch loop that cascades into avatar flickering.
const ORGANIZATION_QUERY_CONFIG = getQueryConfig(FIVE_MINUTES_MS);

export const useOrganization = (organizationId?: string) => {
  return api.contractor.getOrganizationById.useQuery(
    organizationId ? { organizationId } : skipToken,
    ORGANIZATION_QUERY_CONFIG,
  );
};
export const useOrganizationPersonIds = (organizationId?: string) => {
  return api.contractor.getOrganizationPersonIds.useQuery(
    organizationId ? { organizationId } : skipToken,
    ORGANIZATION_QUERY_CONFIG,
  );
};
export const useBidsByOrganization = (organizationId?: string) => {
  return api.contractor.getOrganizationBids.useQuery(
    organizationId ? { organizationId } : skipToken,
    ORGANIZATION_QUERY_CONFIG,
  );
};
